/* eslint-disable import/prefer-default-export */
export const SET_CARD = 'SET_CARD';
export const SET_ACTIVE_THEME_BY_ID = 'SET_ACTIVE_THEME_BY_ID';
export const SET_ACTIVE_SIDE_TO_FIRST_SIDE = 'SET_ACTIVE_SIDE_TO_FIRST_SIDE';
export const SET_ACTIVE_SIDE_BY_ID = 'SET_ACTIVE_SIDE_BY_ID';
export const SET_ACTIVE_LAYER_BY_ID = 'SET_ACTIVE_LAYER_BY_ID';
export const SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT = 'SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT';
export const SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT_TO_NONE = 'SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT_TO_NONE';
export const SET_ACTIVE_LAYER_TO_NONE = 'SET_ACTIVE_LAYER_TO_NONE';
export const SET_KARTENDESIGNER_VISIBILITY = 'SET_KARTENDESIGNER_VISIBILITY';
export const GENERATE_SESSION_ID = 'GENERATE_SESSION_ID';
export const SET_TEXTS = 'SET_TEXTS';
export const SET_SCALE = 'SET_SCALE';
export const SET_PAPER_ID = 'SET_PAPER_ID';
export const SET_WINDOW_DIMENSIONS = 'SET_WINDOW_DIMENSIONS';

// text layer
export const SET_FONT_SIZE_FOR_ACTIVE_LAYER = 'SET_FONT_SIZE_FOR_ACTIVE_LAYER';
export const SET_LINE_HEIGHT_FOR_ACTIVE_LAYER = 'SET_LINE_HEIGHT_FOR_ACTIVE_LAYER';
export const SET_FONT_NAME_FOR_ACTIVE_LAYER = 'SET_FONT_NAME_FOR_ACTIVE_LAYER';
export const SET_FONT_WEIGHT_FOR_ACTIVE_LAYER = 'SET_FONT_WEIGHT_FOR_ACTIVE_LAYER';
export const SET_FONT_STYLE_FOR_ACTIVE_LAYER = 'SET_FONT_STYLE_FOR_ACTIVE_LAYER';
export const SET_FONT_COLOR_FOR_ACTIVE_LAYER = 'SET_FONT_COLOR_FOR_ACTIVE_LAYER';
export const SET_TEXT_ALIGNMENT_FOR_ACTIVE_LAYER = 'SET_TEXT_ALIGNMENT_FOR_ACTIVE_LAYER';
export const SET_TEXT_FOR_ACTIVE_LAYER = 'SET_TEXT_FOR_ACTIVE_LAYER';
export const RESET_TEXT_LAYER_STYLES = 'RESET_TEXT_LAYER_STYLES';

// foto (image) layer
export const SET_CONTRAST_FOR_ACTIVE_LAYER = 'SET_CONTRAST_FOR_ACTIVE_LAYER';
export const SET_BRIGHTNESS_FOR_ACTIVE_LAYER = 'SET_BRIGHTNESS_FOR_ACTIVE_LAYER';
export const SET_SCALE_FOR_ACTIVE_LAYER = 'SET_SCALE_FOR_ACTIVE_LAYER';
export const SET_ROTATION_FOR_ACTIVE_LAYER = 'SET_ROTATION_FOR_ACTIVE_LAYER';
export const SET_TRANSLATE_X_FOR_ACTIVE_LAYER = 'SET_TRANSLATE_X_FOR_ACTIVE_LAYER';
export const SET_TRANSLATE_Y_FOR_ACTIVE_LAYER = 'SET_TRANSLATE_Y_FOR_ACTIVE_LAYER';
export const ACTIVATE_EFFECT_FOR_ACTIVE_LAYER = 'ACTIVATE_EFFECT_FOR_ACTIVE_LAYER';
export const DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER = 'DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER';
export const RESET_IMAGE_LAYER_STYLES = 'RESET_IMAGE_LAYER_STYLES';
export const RESET_IMAGE_LAYER_TRANSFORMATIONS = 'RESET_IMAGE_LAYER_TRANSFORMATIONS';
export const SET_IMAGE_LAYER_URL = 'SET_IMAGE_LAYER_URL';
export const SET_IMAGE_URL_FOR_SELECTED_LAYER = 'SET_IMAGE_URL_FOR_SELECTED_LAYER';

// foto (image) upload
export const ADD_USER_IMAGE = 'ADD_USER_IMAGE';

// theme
export const ACTIVATE_THEME_BY_ID = 'ACTIVATE_THEME_BY_ID';

// tooltips
export const SET_TOOLTIPS_TO_VISIBLE = 'SET_TOOLTIPS_TO_VISIBLE';
export const SET_TOOLTIPS_TO_NOT_VISIBLE = 'SET_TOOLTIPS_TO_NOT_VISIBLE';
export const SET_TOOLTIP_PROPERTIES = 'SET_TOOLTIP_PROPERTIES';

// preview
export const SET_PREVIEW_VISIBILITY = 'SET_PREVIEW_VISIBILITY';
export const SET_PREVIEW_IMAGES = 'SET_PREVIEW_IMAGES';
export const SET_PREVIEW_IMAGES_LOADED = 'SET_PREVIEW_IMAGES_LOADED';

// PDF export / checkout
export const SET_WAITING_FOR_PDF = 'SET_WAITING_FOR_PDF';
export const SET_PDF_URL = 'SET_PDF_URL';
export const SET_CART_IMAGE_URL = 'SET_CART_IMAGE_URL';

// print
export const SET_PRINT_MODE_TO_TRUE = 'SET_PRINT_MODE_TO_TRUE';
export const SET_SCREENSHOT_MODE_TO_TRUE = 'SET_SCREENSHOT_MODE_TO_TRUE';

// layout editing mode
export const SET_LAYOUT_MODE = 'SET_LAYOUT_MODE';
export const SET_LAYER_DIMENSIONS = 'SET_LAYER_DIMENSIONS';
export const TAKE_CARD_OBJECT_SNAPSHOT = 'TAKE_CARD_OBJECT_SNAPSHOT';
export const RESTORE_CARD_OBJECT_SNAPSHOT = 'RESTORE_CARD_OBJECT_SNAPSHOT';
export const DELETE_ACTIVE_LAYER = 'DELETE_ACTIVE_LAYER';
export const DUPLICATE_ACTIVE_LAYER = 'DUPLICATE_ACTIVE_LAYER';
export const CREATE_TEXT_LAYER = 'CREATE_TEXT_LAYER';
export const CREATE_FOTO_LAYER = 'CREATE_FOTO_LAYER';
